import { Component } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

import axios from 'axios';

import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  BankOutlined,
  PushpinOutlined,
  GlobalOutlined,
  ConsoleSqlOutlined,
} from '@ant-design/icons';
import {
  Input,
  Row,
  Col,
  Select,
  Button,
  Checkbox,
  Form,
  notification,
  Modal,
} from 'antd';

import { WPLE_API } from '../api/request';

class WpleBasicDetails extends Component {
  constructor() {
    super(...arguments);

    this.state = {
      approvers: [],
      chosenApprover: '',
      submitting: false,
    };
  }

  completeFileVerification = (extdata, orderID) => {
    let params = {
      action: 'wple_pki_validation',
      imploded: extdata,
      nc: WPLEAPP.nc,
    };

    axios({
      method: 'post',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      url: WPLEAPP.ajax,
      data: params,
    }).then((response) => {
      if (response.data == 'ok') {
        //trigger verify
        //refreshs dcv status and then re-check order status
        WPLE_API('orderstatus', { orderid: orderID, update: true }).then(
          (res) => {
            if (res.success == 'Active') {
              //successful
              this.props.nextStep(3);
              return false;
            } else {
              const { chosenApprover } = this.state;
              //dcv pki is failing
              WPLE_API('setemailauth', {
                orderid: orderID,
                approver: chosenApprover,
              }).then((res) => {});
            }
          }
        );
      }
    });
  };

  onFinish = (values) => {
    ///console.log(values);
    this.setState({ submitting: true });

    WPLE_API('initiateorder', values)
      .then((res) => {
        // if (res.error) {
        //   notification.open({
        //     message: 'Error!',
        //     description: res.error.msg,
        //     duration: 20,
        //   });
        // } else {
        this.setState({ submitting: false });

        if (res.success.toLowerCase() === 'ordered') {
          let orderID = res.extra;
          let breakIndex = res.extra.indexOf('|');

          if (breakIndex >= 0) {
            orderID = orderID.substr(0, breakIndex);
          }

          this.props.setOrderID(orderID);

          if (res.extra.indexOf('|') >= 0) {
            console.log('trying verification');
            this.completeFileVerification(res.extra, orderID);
          }

          this.props.nextStep(2);
        } else if (res.success.toLowerCase() === 'pending') {
          this.props.setOrderID(res.extra);
          this.props.nextStep(2);
        } else if (res.success.toLowerCase() === 'active') {
          this.props.setOrderID(res.extra);
          this.props.nextStep(3);
        } else {
          notification.open({
            message: 'Error!',
            description:
              'Something went wrong. Please contact support@wpencryption.com',
            duration: 20,
          });
        }
        //}
      })
      .catch((error) => {
        this.setState({ submitting: false });
      });
  };

  comodoterms = () => {
    WPLE_API('comodoterms', {}).then((agreement) => {
      Modal.info({
        title: 'Comodo SSL Agreement',
        content: <div>{agreement.success}</div>,
        width: 1000,
        onOk() {},
      });
    });
  };

  componentDidMount() {
    console.log('getting approvers');
    //get approver emails
    WPLE_API('approvers', {}).then((jsonList) => {
      let newList = [];

      for (const [key, item] of Object.entries(jsonList)) {
        let newObj = { value: item, label: item };
        newList.push(newObj);
      }

      //console.log(newList);

      this.setState({ approvers: newList });
    });
  }

  domainChanged = (e) => {
    WPLE_API('approvers', { domain: e.target.value }).then((jsonList) => {
      let newList = [];

      for (const [key, item] of Object.entries(jsonList)) {
        let newObj = { value: item, label: item };
        newList.push(newObj);
      }

      //console.log(newList);

      this.setState({ approvers: newList });
    });
  };

  render() {
    //licenseID,siteurl,approveremail,CSR,fname,lname,phone,email,state,city,country,organization name,agree_to_wpen,agree_to_comodo_agree,
    const { approvers, submitting } = this.state;

    return (
      <div id="wple-certpanel">
        <Form
          name="wple-cert"
          onFinish={this.onFinish}
          initialValues={{ remember: true }}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="domain"
                initialValue={WPLEAPP.site
                  .replace('http://', '')
                  .replace('https://', '')}>
                <Input
                  required
                  size="large"
                  name="domain"
                  addonBefore="Domain Name"
                  defaultValue={WPLEAPP.site
                    .replace('http://', '')
                    .replace('https://', '')}
                  prefix={<GlobalOutlined />}
                  onChange={this.domainChanged}
                />
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="fname" initialValue={WPLEAPP.fname}>
                <Input
                  required
                  size="large"
                  name="fname"
                  addonBefore="First Name"
                  defaultValue={WPLEAPP.fname}
                  prefix={<UserOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="lname" initialValue={WPLEAPP.lname}>
                <Input
                  required
                  size="large"
                  addonAfter="Last Name"
                  name="lname"
                  defaultValue={WPLEAPP.lname}
                  prefix={<UserOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="email" initialValue={WPLEAPP.eml}>
                <Input
                  required
                  size="large"
                  type="email"
                  addonBefore="Email ID"
                  name="email"
                  defaultValue={WPLEAPP.eml}
                  prefix={<MailOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="phone">
                <Input
                  required
                  size="large"
                  type="number"
                  addonAfter="Phone Number"
                  name="phone"
                  prefix={<PhoneOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="organization">
                <Input
                  size="large"
                  name="organization"
                  addonBefore="Organization Name"
                  prefix={<BankOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="state">
                <Input
                  required
                  size="large"
                  addonBefore="State"
                  prefix={<PushpinOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="city">
                <Input
                  required
                  size="large"
                  name="city"
                  addonBefore="City"
                  prefix={<PushpinOutlined />}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="country">
                <Input
                  size="large"
                  required
                  maxLength={2}
                  addonBefore="Country Code"
                  name="country"
                  placeholder="US"
                  prefix={<PushpinOutlined />}
                />
              </Form.Item>
            </Col>
          </Row>
          <br />
          <div class="wple-cert-verify">
            <h3>Choose Verification Email</h3>
            <small>
              IF <b>automatic verification</b> fail then You'll need to click on
              the verification link sent to one of these domain specific email
              IDs.
            </small>
            <Form.Item name="verification">
              <Select
                required
                style={{ width: 300 }}
                size="large"
                name="verification"
                onChange={(val) => {
                  this.props.setApproverEmail(val);
                  this.setState({ chosenApprover: val });
                }}
                options={approvers}
              />
            </Form.Item>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Form.Item name="wpentos">
              <Checkbox value="1" required>
                I Agree to WP Encryption{' '}
                <a
                  href="https://gowebsmarty.com/terms-and-conditions/"
                  target="_blank">
                  terms & conditions
                </a>
              </Checkbox>
            </Form.Item>
            <Form.Item name="comodotos">
              <Checkbox value="1" required>
                I Agree to Comodo{' '}
                <a href="#tos" onClick={this.comodoterms}>
                  terms & conditions
                </a>
              </Checkbox>
            </Form.Item>
            <br />

            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={submitting}
              onFinish={this.onFinish}>
              Submit
            </Button>
            <br />
            <br />
            <small>
              Your provided information is directly sent to the SSL certificate
              authority and its not stored by WP Encryption.
            </small>
          </div>
        </Form>
      </div>
    );
  }
}

export default WpleBasicDetails;
